'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ../~/react-slick/lib/index.js
// module id = 1354
// module chunks = 0